import { getArea } from 'ol/sphere';
import { Circle as CircleGeometry, Polygon } from 'ol/geom';
import { siteConfig } from '../config/site';

export function getGeometryHectares(geometry) {
  if (!geometry) return null;

  if (geometry instanceof CircleGeometry) {
    const radius = geometry.getRadius();
    return (Math.PI * radius * radius) / 10000;
  }

  if (geometry instanceof Polygon) {
    return getArea(geometry) / 10000;
  }

  return null;
}

export function getFeatureHectares(feature) {
  if (!feature?.getGeometry) return null;
  return getGeometryHectares(feature.getGeometry());
}

export function isFieldAreaValid(hectares) {
  if (hectares == null || Number.isNaN(hectares)) return false;
  return hectares >= siteConfig.minHa && hectares <= siteConfig.freeHa;
}

export function getFieldAreaError(hectares) {
  if (hectares == null) return null;

  if (hectares < siteConfig.minHa) {
    return `El lote tiene ${hectares.toFixed(1)} ha. El mínimo permitido es ${siteConfig.minHa} ha.`;
  }

  if (hectares > siteConfig.freeHa) {
    return `El lote tiene ${hectares.toFixed(1)} ha. El máximo permitido es ${siteConfig.freeHa} ha.`;
  }

  return null;
}
